import * as React from "react";
import C from "classnames";
export const FormGroup = ({ children, className, row, testId, style, }) => {
    return (React.createElement("div", { className: C("form-group", row && "row", className && className), style: style, "data-testid": testId }, children));
};
//# sourceMappingURL=FormGroup.js.map